import React from 'react';
import { getMarkDown } from '../utils';
import { ReactComponent as OopsIcon } from '../../../assets/Alert.svg';
import { ReactComponent as TimeoutIcon } from '../../../assets/Alert.svg';
import { ReactComponent as ConnectionIcon } from '../../../assets/Connection.svg';
import Footer from './Footer';
import '../../../stylesheets/triagebot/Errors.scss';

const alertContent = {
    english: {
        timeoutHeader: '**Timeout Error**',
        timeoutText: 'This experience has timed-out. Please relaunch the app from Mychart to start again.',
        connectionHeader: '**Connection Error**',
        connectionRestartText: "We're having trouble connecting. Please click **restart**.",
        connectionRefreshText: "We're having trouble connecting. Please refresh the page to start again.",
        sessionTimeoutHeader: '**Session Timeout**',
        sessionTimeoutText: 'Your session is complete. Please do not refresh the page. Instead, re-launch Symptom Smart from the MyChart app.',
        defaultHeader: '**Oops!**',
        defaultText: 'Something went wrong on our end. We apologize for the inconvenience.',
        refreshButton: 'Refresh'
    },
    spanish: {
        timeoutHeader: '**Se agotó el tiempo de espera**',
        timeoutText: 'Se agotó el tiempo de espera de esta experiencia. Vuelva a iniciar la aplicación desde MyChart para comenzar de nuevo.',
        connectionHeader: '**Error de conexión**',
        connectionRestartText: 'Tenemos problemas para conectarnos. Haga clic en **actualizar**.',
        connectionRefreshText: 'Tenemos problemas para conectarnos. Actualice la página para comenzar de nuevo.',
        sessionTimeoutHeader: '**Tiempo de sesión agotado**',
        sessionTimeoutText: 'Su sesión se ha completado. No actualice la página. En su lugar, vuelva a iniciar Symptom Smart desde la aplicación MyChart.',
        defaultHeader: '**Oops!**',
        defaultText: 'Algo salió mal de nuestro lado. Pedimos disculpas por las molestias.',
        refreshButton: 'Actualizar'
    }
};

const AlertMessage = ({ message, sendMessage, allowRestart, isSpanish = false }) => {
    var headerText = (message.data && message.data.length && message.data[0].headerText)
        ? message.data[0].headerText
        : ''

    allowRestart = (allowRestart && allowRestart.toUpperCase && (allowRestart.toUpperCase() === 'TRUE'));
    const content = isSpanish ? alertContent.spanish : alertContent.english;

    var isConnection = false;
    let icon;
    let bodyText = message.text;

    switch (message.type.toLowerCase()) {
        case 'timeout':
            icon = <TimeoutIcon className='timeout large' />
            headerText = content.timeoutHeader
            bodyText = content.timeoutText
            break;
        case 'connecterr':
            icon = <ConnectionIcon className='small' />
            headerText = content.connectionHeader
            bodyText = allowRestart
                ? content.connectionRestartText
                : content.connectionRefreshText
            isConnection = true;
            break;
        case 'oops':  // Symptom Checker server errors 
            icon = <OopsIcon className='alert' />
            break;
        case 'sessiontimeout':        
            icon = <TimeoutIcon className='timeout large' />
            headerText = content.sessionTimeoutHeader
            bodyText = isSpanish
                ? content.sessionTimeoutText
                : (bodyText || content.sessionTimeoutText)
            break;
        default:     // Infermetica errors
            icon = <OopsIcon className='alert' />
            headerText = content.defaultHeader
            bodyText = content.defaultText
    }

    return (
        <div className='alert card'>
            <div className='content'>
                <div className='icon' style={isConnection ? { minWidth: '126px' } : {}}>
                    {icon}
                </div>
                <div>
                    <div className='header'>
                        {getMarkDown(headerText)}
                    </div>
                    <div className='body'>
                        {getMarkDown({ ...message, text: bodyText })}
                    </div>
                </div>
            </div>
            {
                allowRestart &&
                <Footer>
                    <button
                        className={'submit-button'}
                        onClick={() => sendMessage('restart', 'Reset', 'Reset')}
                    >
                        {content.refreshButton}
                </button>
                </Footer>
            }
        </div>
    );
}

export default AlertMessage;
